import { get, set } from "vue-cookie";

/**
 * 쿠키 관련 모듈
 * - vue.js 전용
 */
export default {

    /**
     * 쿠키 등록
     * @param {String} name : 쿠키 명
     * @param {String} value : 등록할 쿠키 값
     * @param {*} daysOrOptions : 쿠키 만료일 또는 옵션 값
     */
     setCookie: (name, value, daysOrOptions) => {

        let valueString = escape(value);
        set(name, valueString, daysOrOptions);
    },

    /**
     * 쿠키 값 반환
     * @param {String} name : 쿠키 명
     * @returns JSON 형식으로 쿠키 값 반환
     */
    getCookie: (name) => {

        let value = unescape(get(name));
        return !value ? null : value;
    },

    /**
     * JSON 형식의 데이터로 쿠키 등록
     * @param {String} name : 쿠키 명
     * @param {JSON} jsonData : 등록할 쿠키 값 (JSON 형식)
     * @param {*} daysOrOptions : 쿠키 만료일 또는 옵션
     */
    setCookieToJSON: (name, jsonData, daysOrOptions) => {

        let valueString = escape(JSON.stringify(jsonData));
        set(name, valueString, daysOrOptions);
    },

    /**
     * JSON 형식의 데이터로 쿠키 값 반환
     * @param {String} name : 쿠키 명
     * @returns JSON 형식으로 쿠키 값 반환
     */
    getCookieToJSON: (name) => {

        let value = unescape(get(name));
        return !value ? null : JSON.parse(value);
    }
}